/**
 * @module
 *
 * @author Jacob Viertel [jv@onscreen.net](mailto:jv@onscreen.net)
 *
 * @import {ListPosition} from "@acng/frontend-discovery";
 */

import {Context} from '@acng/frontend-relativity';

/**
 * @type {Local<ListPosition | null>}
 */
export const ctxListPosition = Context();
